import { Layer, FsqPlacesSort, TLayersConfig, MapType } from './types';
import {
  mapEducations,
  mapShopping,
  mapTransport,
  mapParks,
  mapHospitals,
  mapRestaurants,
  mapGyms,
  mapPharmacies,
  mapEntertainment,
  mapBanks,
} from '../../config/icons';

export const layerTranslations = {
  educations: 'מוסדות חינוך',
  shopping: 'קניות',
  transport: 'תחבורה',
  parks: 'פארקים',
  hospitals: 'בתי חולים',
  restaurants: 'מסעדות',
  gyms: 'חדרי כושר',
  pharmacies: 'בתי מרקחת',
  entertainment: 'בידור',
  banks: 'בנקים',
};

export const nearbyPlacesSearchRadius = 3000;

export const MapTypeToStyle = {
  [MapType.Roadmap]: 'mapbox://styles/mapbox/streets-v12',
  [MapType.Satellite]: 'mapbox://styles/mapbox/satellite-v9',
};

export const layersConfig: TLayersConfig = {
  [Layer.Educations]: {
    icon: mapEducations,
    categories: ['4bf58dd8d48988d13b941735'],
  },
  [Layer.Shopping]: {
    icon: mapShopping,
    categories: [
      '52dea92d3cf9994f4e043dbb',
      '63be6904847c3692a84b9bec',
      '4bf58dd8d48988d1f8941735',
      '50be8ee891d4fa8dcc7199a7',
      '4bf58dd8d48988d1fd941735',
    ],
  },
  [Layer.Transport]: {
    icon: mapTransport,
    categories: [
      '4bf58dd8d48988d12a951735',
      '5f2c42335b4c177b9a6dc927',
      '56aa371be4b08b9a8d57352f',
      '63be6904847c3692a84b9c29',
      '63be6904847c3692a84b9c2a',
      '4bf58dd8d48988d1fe931735',
      '52f2ab2ebcbc57f1066b8b4f',
      '56aa371ce4b08b9a8d57356e',
      '4bf58dd8d48988d1fc931735',
      '5f2c1af1b6d05514c704319d',
      '4bf58dd8d48988d1fd931735',
      '4bf58dd8d48988d129951735',
      '52f2ab2ebcbc57f1066b8b51',
      '63be6904847c3692a84b9c2b',
      '63be6904847c3692a84b9c2d',
      '4bf58dd8d48988d12b951735',
    ],
    sort: FsqPlacesSort.Distance,
  },
  [Layer.Parks]: {
    icon: mapParks,
    categories: ['4bf58dd8d48988d163941735'],
  },
  [Layer.Hospitals]: {
    icon: mapHospitals,
    categories: [
      '4bf58dd8d48988d196941735',
      '63be6904847c3692a84b9bc0',
      '58daa1558bbb0b01f18ec1f7',
      '56aa371be4b08b9a8d5734ff',
      '4bf58dd8d48988d104941735',
    ],
  },
  [Layer.Restaurants]: {
    icon: mapRestaurants,
    categories: ['4d4b7105d754a06374d81259'],
  },
  [Layer.Gyms]: {
    icon: mapGyms,
    categories: ['4bf58dd8d48988d175941735'],
  },
  [Layer.Pharmacies]: {
    icon: mapPharmacies,
    categories: [
      '5745c2e4498e11e7bccabdbd',
      '58daa1558bbb0b01f18ec206',
      '4bf58dd8d48988d10f951735',
    ],
  },
  [Layer.Entertainment]: {
    icon: mapEntertainment,
    categories: ['4d4b7104d754a06370d81259'],
  },
  [Layer.Banks]: {
    icon: mapBanks,
    categories: ['63be6904847c3692a84b9b3f'],
  },
};
